import { useCallback, useState } from 'react';
import { useExport } from '@/shared/hooks/useExport';

/**
 * Shared export state for dataset download flows (Data Editor toolbar,
 * SDK-removal modal, etc.).
 */
export function useDatasetExport() {
    const { exportData } = useExport();
    const [exporting, setExporting] = useState(false);
    const [exportPercent, setExportPercent] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const runExport = useCallback(
        ({ requestData, filename, onSuccess, onError }) => {
            if (exporting) {
                return;
            }
            setExporting(true);
            setExportPercent(null);
            setDropdownOpen(false);

            exportData(
                'download-dataset',
                requestData,
                filename,
                () => {
                    setExporting(false);
                    setExportPercent(null);
                    onSuccess?.();
                },
                (error) => {
                    setExporting(false);
                    setExportPercent(null);
                    onError?.(error);
                },
                { onProgress: (pct) => setExportPercent(pct) }
            );
        },
        [exportData, exporting]
    );

    return {
        runExport,
        exporting,
        exportPercent,
        dropdownOpen,
        setDropdownOpen,
    };
}
